import React, { useState, useRef, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import jp from "jsonpath";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { PanelMenu } from "primereact/panelmenu";
import { OverlayPanel } from "primereact/overlaypanel";
import { SidePanel } from "../sidepanel/SidePanel";
import { NewCustomDialog, NewDialogProps } from "../dialog/NewCustomDialog";
import { LANGUAGE_OPTIONS, functionalitiesCodesExtras } from "../../constants";
import { auth } from "../../services/iam/auth";
import IBModuleApi from "../../api/iuviBankingAPI";
import { AppContext } from "../../context";
import logo from "../../assets/bankname.svg";
import { useMediaQuery, useMessages } from "iuvity-ui-components/dist/hooks";
import { formatDateTime } from "../../helpers/formatDate";
import { useMenu } from "../../hooks/useMenu"
import mainTenantIsotypeLogo from "../../assets/isotipo_iuvity.png";
import { useTenantBranding } from "../../hooks/useTenantBranding";
import { useTenants } from "../../hooks/useTenants";
import { DataBranding } from "../../interfaces";
import { Messages } from "iuvity-ui-components/dist/messages";
import { Checkbox } from "primereact/checkbox";
import { useIdleTimer } from 'react-idle-timer';
import { urlContexts } from "../../constants";
import { getUserInfo } from "../../services/iam/getUserInfo";
import { useUserRole } from "../../hooks/useUserRole";

export interface HeaderProps {
  welcomeMessage: string;
  overlayContent?: React.ReactNode;
  urlAvatar?:
  | string
  | "https://www.primefaces.org/primereact/images/avatar/amyelsner.png";
  userName?: string;
}

export const Header: React.FC<HeaderProps> = ({ welcomeMessage = "" }) => {
  const isBigScreen = useMediaQuery('(min-width: 1920px)');
  const op_settings = useRef<OverlayPanel>(null);
  const op_profile = useRef<OverlayPanel>(null);
  const navigate = useNavigate();
  const {
    t,
    // toast,
    appState: {
      user, language, selectedApp, expires_in, timeToExpire, selectedTenantId,
      tenantId, appRoles, tenantParentName, dataBrandingObject, showChangeAppButton,
      tenantIdListsNavigations, showChangeClientButton, tenantAuth, tokenExpireTime,
      refreshToken, ip, activateAlert, keepAlive, sessionTimeOut, functionalityCode,
      refreshRolePermissions,
    },
    setAppState,
  } = useContext(AppContext);
  const [enableSidepanel, setEnableSidepanel] = useState<boolean>(false);
  const [modalProps, setModalProps] = useState<NewDialogProps>({
    visible: false,
  } as NewDialogProps);
  const lastAccessDate = formatDateTime(t, language);
  const [menuType, setMenuType] = useState<"EXTERNAL" | "INTERNAL">('EXTERNAL');
  const [infObject, setInfObject] = useState<{
    tenantid: string,
    roleid?: string,
    appid?: string,
    environmentid?: string,
  }>({tenantid: tenantId});
  const { data: dataRolesByTenant, reloadFn: reloadDataRolesByTenant } = useUserRole("DATA", infObject?.tenantid);
  const [showLangComponent, setShowLangComponent] = useState<boolean>(false);
  const [hasAlert, setHasAlert] = useState<boolean>(false);
  const [alertEnvironmentCheckbox, setAlertEnvironmentCheckbox] = useState<boolean>(false);
  const { menu, reloadFn } = useMenu(menuType, infObject);
  const [functionalitiesCodesMap, setFunctionalitiesCodesMap] = useState<any>({});
  const menuCompleted = [
    {},
    ...((menu.find((item:any)=>item?.label === 'accessMenuLabel') || selectedApp)
      ? [...menu]
      : [...menu, {
        label: "accessMenuLabel",
        icon: "iu iu-icon-access",
        target: "",
        targettype: "INTERNAL",
        order: 3,
        items: [],
    }]),
    {
      "label": "ChangeApplication",
      "icon": "iu iu-icon-develop",
      "isHidden": !selectedApp || !showChangeAppButton,
      "actionType": "change",
    },
    {
      "label": "ChangeClient",
      "icon": "iu iu-icon-support",
      "isHidden": ((tenantId === tenantAuth) && !selectedTenantId) || !showChangeClientButton,
      "actionType": "change",
    }
  ];
  const { getBrandingInfo } = useTenantBranding("DATA");
  const { getInfoChildrenTenants } = useTenants("CHILDREN");
  const { messageRef, handleMessage } = useMessages();

  //***** obtención del tipo de rol *****/
  const isAdminRoleType = dataRolesByTenant?.length > 0 && !!dataRolesByTenant?.find((role:any) => role?.isAdministrative);
  //***** obtención del tipo de rol *****/

  //***** Permiso Versiones Canal Digital *****/
  const findVersionFunctionalityInRole = (data:any) => {
    return data?.length > 0 && data?.filter((role:any) => !!(
      role?.rolePermissions?.find((permission:any) => permission?.functionalityId === 'COD_VCD' || permission?.functionalityId === 'COD_VCDA')
    ))?.length > 0
  };

  const dataForFindVersion = !!selectedApp
    ? dataRolesByTenant?.filter((roleItem:any)=>roleItem?.id === selectedApp.roleid)
    : dataRolesByTenant?.filter((roleItem:any)=>roleItem?.isAdministrative);

  const showVersionsMenuOption = findVersionFunctionalityInRole(dataForFindVersion);
  //***** Permiso Versiones Canal Digital *****/

  useEffect(()=>{
    let functionalitiesCodesMapAux:any = {};
    menu?.map((levelOne:any)=>{
      functionalitiesCodesMapAux = { ...functionalitiesCodesMapAux, [levelOne?.target]: levelOne?.functionalityId };
      levelOne?.hasOwnProperty('items') && levelOne?.items.map((levelTwo:any)=>{
        functionalitiesCodesMapAux = { ...functionalitiesCodesMapAux, [levelTwo?.target]: levelTwo?.functionalityId };
        levelTwo?.hasOwnProperty('items') && levelTwo?.items.map((levelThree:any)=>{
          functionalitiesCodesMapAux = { ...functionalitiesCodesMapAux, [levelThree?.target]: levelThree?.functionalityId };
          levelThree?.hasOwnProperty('items') && levelThree?.items.map((item:any)=>{
            functionalitiesCodesMapAux = { ...functionalitiesCodesMapAux, [item?.target]: item?.functionalityId };
          })
        })
      });
    });
    menu?.length > 0 && setFunctionalitiesCodesMap({ ...functionalitiesCodesMapAux, ...functionalitiesCodesExtras });

    // Aquí se setea el contexto con el mapa de códigos/funcionalidades para usarlo en los dashboards
    setAppState((prev) => ({
      ...prev,
      infoObjRolesByTenantState: {
        ...prev.infoObjRolesByTenantState,
        functionalitiesCodesMap: { ...functionalitiesCodesMapAux }
      }
    }));
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[menu]);

  // Permmissions controller
  // ***********************
  useEffect(()=>{
    let functCode = functionalitiesCodesMap?.hasOwnProperty('/') && functionalitiesCodesMap[
      ( ['adminroles','users','translations', 'functionalities'].includes(functionalityCode.split('/')[1])
        ? `/${functionalityCode.split('/')[1]}`
        : functionalityCode
      ) ?? '/'];
    let privilegesValues = {
      CREATE: false,
      READ: false,
      UPDATE: false,
      REMOVE: false,
    }
    if (dataRolesByTenant?.length > 0) {
      const dataRolesByTenantGlobal = !!selectedApp
        ? dataRolesByTenant?.filter((roleItem:any)=>roleItem?.id === selectedApp.roleid)[0]
        : dataRolesByTenant?.filter((roleItem:any)=>roleItem?.isAdministrative)[0];
        
      // Envío al context la data de roles por tenant para usarla en los dashboards.
      setAppState((prev)=>({
        ...prev,
        infoObjRolesByTenantState: {
          ...prev.infoObjRolesByTenantState,
          dataRolesByTenantGlobal: dataRolesByTenantGlobal?.rolePermissions,
        },
        adminRoleId: (!!dataRolesByTenantGlobal && dataRolesByTenantGlobal?.hasOwnProperty('id')) ? dataRolesByTenantGlobal?.id : undefined,
      }));

      !!functCode && !!dataRolesByTenantGlobal && jp.query(dataRolesByTenantGlobal, `$..[?(@.functionalityId=="${functCode}")].permission.privilegeId`)
      // eslint-disable-next-line array-callback-return
      ?.map((privilege:string) => {
        privilegesValues = { ...privilegesValues, [privilege]: true };
      });
    }

    setAppState((prev)=>({
      ...prev,
      permissiondInfoByRole: privilegesValues,
    }));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dataRolesByTenant, functionalityCode, selectedApp, setAppState]);

  const handleModalProps = (actionType: "change" | "logout" | "role" | "alert" | any, removeTenantId: boolean, e?: any) => {
    switch (actionType) {
      case "change":
        return setModalProps((prev) => ({
          ...prev,
          visible: true,
          title: t("AppSelector.appSelectorChangeModalTitle"),
          content: t("AppSelector.appSelectorChangeModalContent"),
          onConfirm: () => onUnselectApp(removeTenantId, e),
          closable: true,
          acceptLabel: t("Options.acceptOptionLabel"),
          rejectLabel: t("Options.rejectOptionLabel"),
        }));
      case "logout":
        return setModalProps((prev) => ({
          ...prev,
          visible: true,
          title: t("Login.sessionCloseModalTitle"),
          content: t("Login.cancelModalContent"),
          onConfirm: onLogout,
          closable: false,
          acceptLabel: t("Options.acceptOptionLabel"),
          rejectLabel: t("Options.rejectOptionLabel"),
        }));
      case "role":
        return setModalProps((prev) => ({
          ...prev,
          visible: true,
          title: t("Roles.roleSelectorModalTitle"),
          content: t("Roles.roleSelectorModalContent"),
          onConfirm: () => onRoleSelection(e),
          closable: false,
          acceptLabel: t("Options.acceptOptionLabel"),
          rejectLabel: t("Options.rejectOptionLabel"),
        }));
      case "alert":
        return setModalProps((prev) => ({
          ...prev,
          visible: true,
          title: t("Environments.alertEnvironmentModalTitle"),
          content: alertEnvironmentContent(alertEnvironmentCheckbox, setAlertEnvironmentCheckbox),
          onConfirm: () => onAlertEnvirontmentHide(alertEnvironmentCheckbox),
          onReject: () => {
            setAlertEnvironmentCheckbox(false);
            setModalProps({ visible: false });
          },
          closable: false,
          acceptLabel: t("Options.acceptOptionLabel"),
          rejectLabel: t("Options.rejectOptionLabel"),
        }));
      default:
        return;
    }
  };

  const onUnselectApp = async (removeTenantId: boolean, e?: any) => {
    setEnableSidepanel(false);
    IBModuleApi.defaults.baseURL = "";
    sessionStorage.removeItem("ENV");
    if (removeTenantId) {
      const arrayNavigation: any = tenantIdListsNavigations.filter(item => item !== tenantIdListsNavigations[tenantIdListsNavigations.length - 1]);

      if (arrayNavigation?.length <= 1) {
        window.location.reload();
      } else {
        const newTenantId = selectedApp ? tenantId : arrayNavigation[arrayNavigation.length - 1];
        const tenant = await Promise.resolve(getInfoChildrenTenants(newTenantId));

        setAppState((prev) => ({
          ...prev,
          selectedTenantId: null,
          tenantId: newTenantId,
          tenantIdListsNavigations: arrayNavigation,
          selectedApp: null,
          tenantParentName: tenant[0]?.name,
        }));

        // NAVIGATE SOLO DEBE LLAMARSE PREVIO AL BRANDING (DO NOT MOVE)
        navigate("/");
        const dataBranding: DataBranding = await Promise.resolve(getBrandingInfo(newTenantId));
        if (dataBranding) {
          setAppState((prev) => ({
            ...prev,
            dataBrandingObject: dataBranding,
          }));
        }
      }

    } else {
      navigate("/");
      setAppState((prev) => ({
        ...prev,
        selectedApp: null,
      }));
      !!e && op_profile.current?.toggle(e);
    }
  };

  const onRoleSelection = async (e: any) => {
    setMenuType("INTERNAL");
    setInfObject((prev: any) => ({
      ...prev,
      roleid: e?.roleId,
    }));
    setAppState((prev: any) => ({
      ...prev,
      selectedApp: {
        ...prev.selectedApp,
        roleid: e?.roleId,
        rolename: e?.roleName,
      },
      reloadQuickLinks: true,
    }));
    const selectAppData: any = selectedApp;
    await auth.selectRoleAction(selectAppData.tenantid, selectAppData?.appid, e.roleId, selectAppData?.segment, selectAppData?.env);
    navigate("/");
  }

  const onAlertEnvirontmentHide = (checkedState: boolean) => {
    const checkboxElm = document?.getElementsByName('alert-environment-checkbox')?.item(0);
    messageRef?.current?.clear();
    //@ts-ignore
    checkboxElm?.checked && sessionStorage.setItem("ENVIRONMENT::ALERT", "true");
    setHasAlert(false);
    setModalProps({ visible: false });
  }

  const alertEnvironmentContent = (checkedState: boolean, setCheckedState: Function) => {
    let testCheckboxValue = checkedState;

    return (
      <div>
        {/* <span className="p-confirm-dialog-message">
        {t("Environments.alertEnvironmentModalContent")}
      </span> */}
        <div
          style={{
            display: "flex",
            gap: "16px",
          }}
        >
          <div
            style={{
              width: "min-content",
            }}
            onClick={() => {
              testCheckboxValue = !testCheckboxValue;
              const checkboxElm = document?.getElementsByName('alert-environment-checkbox')?.item(0);
              const checkboxBg = document?.getElementsByClassName('p-checkbox-box')?.item(0);
              const checkboxIcon = document?.getElementsByClassName('p-checkbox-icon')?.item(0);
              // @ts-ignore
              if (testCheckboxValue !== checkboxElm?.checked) {
                // @ts-ignore
                checkboxElm.checked = testCheckboxValue;
                //@ts-ignore
                testCheckboxValue ? checkboxBg!.classList.add('p-highlight') : checkboxBg!.classList.remove('p-highlight');
                //@ts-ignore
                testCheckboxValue ? checkboxIcon!.classList.add('pi') : checkboxIcon!.classList.remove('pi');
                //@ts-ignore
                testCheckboxValue ? checkboxIcon!.classList.add('pi-check') : checkboxIcon!.classList.remove('pi-check');
                setCheckedState(testCheckboxValue);
              }
            }}
          >
            <Checkbox
              name="alert-environment-checkbox"
            />
          </div>
          <p>{t("Environments.alertEnvironmentCheckboxDescription")}</p>
        </div>
      </div>)
  };

  const changeLanguage = (newLanguage: string, e: any) => {
    op_profile.current?.toggle(e);
    setAppState((prev) => ({
      ...prev,
      language: newLanguage,
    }));
    window.IBPeventCreator("CHANGE::LANGUAGE", newLanguage);
  };

  const onLogout = (hasRedirection: boolean = true) => {
    // ENVIO DE LOGOUT AL LOCALSTORAGE
    const iframe = document.getElementById("iframe-logout");
    if (iframe) {
      // @ts-ignore
      iframe.contentWindow.postMessage(
        {
          key: "IS::LOGOUT",
          value: "true",
        },
        "*"
      );
    }

    IBModuleApi.defaults.baseURL = "";
    const token: string = sessionStorage?.getItem('REDIRECT::INFO') || '';
    clearTimeout(parseInt(sessionStorage?.getItem('TIMERID::REFRESH') ?? '0', 10));
    clearTimeout(parseInt(sessionStorage?.getItem('TIMERID::KEEPALIVE') ?? '0', 10));
    sessionStorage.clear();
    setAppState((prev) => ({
      ...prev,
      user: null,
      selectedApp: null,
      tokenExpireTime: 0,
    }));
    auth.doLogout(hasRedirection, token);
    localStorage.setItem("IS::LOGOUT", 'true');

  };

  const onIdle = () => {
    if (!sessionStorage.getItem('ONIDLE::INACTIVITY')) {
      sessionStorage.setItem('ONIDLE::INACTIVITY', 'true');
      setModalProps((prev) => ({
        ...prev,
        visible: true,
        title: t("Login.inactivitySessionTitle"),
        content: t("Login.inactivitySessionDescription")
          .replace("{firstAlertTime}", expires_in / 60)
          .replace("{remainingTime}", timeToExpire / 60),
        onConfirm: () => {
          // auth.doUpdateToken();
          sessionStorage.removeItem('ONIDLE::INACTIVITY');
          clearTimeout(closeModalTimeID);
        },
        closable: false,
        acceptLabel: t("Login.continueButton"),
        rejectLabel: t("Login.closeSessionButton"),
        onReject: onLogout,
      }));
      const closeModalTimeID = setTimeout(() => {
        const token: string = sessionStorage?.getItem('REDIRECT::INFO') || '';
        clearTimeout(parseInt(sessionStorage?.getItem('TIMERID::REFRESH') ?? '0', 10));
        clearTimeout(parseInt(sessionStorage?.getItem('TIMERID::KEEPALIVE') ?? '0', 10));
        sessionStorage.clear();
        sessionStorage.setItem('ONIDLE::INACTIVITY', 'true');
        setModalProps((prev) => ({
          ...prev,
          visible: true,
          title: t("Login.closeSessionTitle"),
          content: t("Login.closeSessionDescription"),
          onConfirm: () => {
            document.getElementById('pr_id_1')?.remove();
            window.location.href = (
              (process.env['REACT_APP_IAM_FRONT_HOST']
                ? process.env['REACT_APP_IAM_FRONT_HOST']
                : process.env['REACT_APP_BACKEND_HOST'])
              || 'http://localhost:3001') + '/' + urlContexts.iam_front;
          },
          closable: false,
          acceptLabel: t("Login.acceptButton"),
          onReject: "close",
        }));
        setAppState((prev) => ({
          ...prev,
          tokenExpireTime: 0,
        }));
        auth.doLogout(false, token);
        document
          .getElementById("pr_id_1")
          ?.parentElement?.classList.add("body-mask-black");

        // Elimina los elementos del DOM con las clases descritas. En la
        // presentación de la modal de cierre de sesión por inactividad.
        document?.getElementsByClassName('main-content')[0]?.remove();
        document?.getElementsByClassName('p-datepicker')[0]?.remove();
      }, (timeToExpire - 1) * 1000);
    }
  }

  useIdleTimer({
    onIdle,
    timeout: expires_in * 1000,
  })

  useEffect(() => {
    if (tokenExpireTime !== 0) {
      const timeOutRefreshToken = setTimeout(async () => {
        await auth.refreshToken();
        setAppState((prev) => ({
          ...prev,
          refreshToken: !refreshToken
        }))
      }, tokenExpireTime * 1000);
      sessionStorage.setItem('TIMERID::REFRESH', timeOutRefreshToken.toString());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshToken]);

  useEffect(() => {
    if (tokenExpireTime !== 0) {
      const timeOutKeepAlive = setTimeout(async () => {
        await getUserInfo();
        setAppState((prev) => ({
          ...prev,
          keepAlive: !keepAlive
        }))
      }, (sessionTimeOut - 20) * 1000);
      sessionStorage.setItem('TIMERID::KEEPALIVE', timeOutKeepAlive.toString());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keepAlive]);

  const OverlayRoleSelectorContent = () => {
    return (
      <div className="overlay-content-box">
        <p
          className="overlay-content-box__role-selector-title"
          style={{
            fontFamily: "var(--fontBarlowSemiBold)",
            fontSize: "var(--font-size-xl)",
          }}
        >{t('UserInformation.changeRole')}</p>
        <Divider className="" />
        <PanelMenu
          className="op_panelmenu-1 role-selector-items"
          model={appRoles
            ? [{}, ...appRoles
              .sort((roleA:any, roleB:any) => {
              if (roleA.roleName < roleB.roleName) {
                return -1;
              }
              if (roleA.roleName > roleB.roleName) {
                return 1;
              }
              return 0;  
            })
            .map((role: any) => ({
              label: role?.roleName,
              command: role?.roleId !== selectedApp?.roleid
                ? () => handleModalProps('role', false, role)
                : (e: any) => op_settings.current?.toggle(e),
            }))
            ]
            : []}
        />
      </div>
    );
  };

  // CAMBIO DE MENU
  useEffect(() => {
    if (!!selectedApp) {
      setMenuType("INTERNAL");
      setInfObject((prev) => ({
        ...prev,
        tenantid: selectedApp?.tenantid,
        roleid: selectedApp?.roleid,
        appid: selectedApp?.appid,
        environmentid: selectedApp?.envid
      }));
      sessionStorage.removeItem('CONSOLE::MENU');
    } else {
      setMenuType("EXTERNAL");
      sessionStorage.removeItem('CONSOLE::MENU');
    };
    if ((!!selectedTenantId || !!tenantId) && !selectedApp) {
      setInfObject({
        tenantid: selectedTenantId ? selectedTenantId : tenantId
      });
      sessionStorage.removeItem('CONSOLE::MENU');
    };
    reloadFn();
    // Esta función me permite setear el hook de obtención de roles by tenant.
    reloadDataRolesByTenant();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedApp, selectedTenantId, tenantId, refreshRolePermissions]);

  const OverlayProfileContent = () => {
    return !showLangComponent ? (
      <div>
        {
          selectedApp && showChangeAppButton &&
          <p
            className="sc-menu-btn py-3"
            onClick={(e) => handleModalProps("change", false, e)}
            style={{
              fontFamily: "var(--fontBarlowMedium)",
            }}
          >
            <i className="iu iu-icon-develop mr-2" />
            {t("UserInformation.changeApplication")}
          </p>
        }
        {
          ((tenantId !== tenantAuth) || selectedTenantId) && showChangeClientButton &&
          <p
            className="sc-menu-btn py-3"
            onClick={(e) => handleModalProps("change", true, e)}
            style={{
              fontFamily: "var(--fontBarlowMedium)",
            }}
          >
            <i className="iu iu-icon-support mr-2" />
            {t("UserInformation.changeClientLink")}
          </p>
        }
        {
          showVersionsMenuOption &&
          <p
            className="sc-menu-btn py-3"
            onClick={(e) => navigate("/versions")}
            style={{
              fontFamily: "var(--fontBarlowMedium)",
            }}
          >
            <i className="iu iu-icon-list mr-2" />
            {t(t("Versions.versionsBreadcrumbLabel"))}
          </p>
        }
        <div
          className="change-lang-link flex align-items-center justify-content-between py-3"
          onClick={() => setShowLangComponent(true)}
        >
          <p
            style={{
              fontFamily: "var(--fontBarlowMedium)",
            }}
          >
            <i className="iu iu-icon-world mr-2" />
            {t("UserInformation.changeLanguageLink")}
          </p>
          <p
            className="lan-btn"
          >
            {language.toUpperCase()}
          </p>
        </div>

        {/* <div className="flex align-items-center justify-content-between">
            <p>{t("UserInformation.darkModeLink")}</p>
            <InputSwitch checked={value} onChange={(e) => setValue(e.value)} />
          </div> */}
        <Divider className="my-0" />
        <p
          className="sc-menu-btn py-3"
          onClick={() => handleModalProps("logout", false)}
          style={{
            fontFamily: "var(--fontBarlowMedium)",
          }}
        >
          <i className="iu iu-icon-exit mr-2" />
          {t("UserInformation.closeSessionButton")}
        </p>
        <Divider className="mt-0 mb-4" />
        <p
          className="us-info-time-ip mt-0"
          style={{
            fontFamily: "var(--fontBarlowRegular)",
            fontSize: "var(--font-size-xs)",
            textAlign: "right",
          }}
        >
          IP: {ip}
        </p>
        <p
          className="us-info-time-ip mt-2"
          style={{
            fontFamily: "var(--fontBarlowRegular)",
            fontSize: "var(--font-size-xs)",
            textAlign: "right",
          }}
        >
          {lastAccessDate}
        </p>
      </div>
    ) : (
      <div className="overlay-language-box">
        <div
          className="flex align-items-center"
          onClick={() => setShowLangComponent(false)}
          style={{
            cursor: "pointer",
          }}
        >
          <i
            className="iu iu-icon-left"
            style={{
              marginRight: "var(--space-s)",
            }}
          />
          <p className="overlay-language-box__lang-selector-title">{t('UserInformation.changeLanguageLink')}</p>
        </div>
        <Divider className="" />
        <PanelMenu
          className="op_panelmenu-1"
          model={[
            {},
            ...LANGUAGE_OPTIONS(t)
              ?.map((langItem) => ({
                label: `${langItem.label} - ${langItem.value.toUpperCase()}`,
                command: langItem.value === language ? (e: any) => op_profile.current?.toggle(e) : (e: any) => changeLanguage(langItem.value, e),
                className: "lang-item"
              }))
              ?.sort((a, b) => a.label.localeCompare(b.label))
          ]}
        />
      </div>
    );
  };

  useEffect(() => {
    if (showChangeAppButton && !sessionStorage.getItem('ENVIRONMENT::ALERT')) {
      let envTranslation = t('Environments.' + selectedApp?.env.toUpperCase() + 'Label');
      envTranslation = envTranslation.includes('Environments') ? selectedApp?.env : envTranslation?.toUpperCase();

      handleMessage({
        severity: "warn",
        sticky: true,
        detail: `${t('Environments.environmentAlertMessage')} [${envTranslation}]`,
        closable: false,
      });
      setHasAlert(true);
    };
    !selectedApp && messageRef?.current?.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedApp, selectedTenantId, tenantId, language, activateAlert]);

  return (
    <React.Fragment>
      <header>
        <nav className="flex justify-content-between p-menunavbar h-5rem">
          <div className="flex">
            <div className="flex align-items-center">
              <Button
                className="lg:ml-3 p-button-header"
                icon={
                  <span
                    className="p-button-icon p-c iu iu-icon-menu"
                    style={{ color: "var(--cardBackgroundColorOne)" }}
                  />
                }
                style={{
                  backgroundColor: (enableSidepanel || isBigScreen) ? 'var(--backgroundHoverButtonHeader)' : 'var(--mainColor)',
                }}
                onClick={isBigScreen ? undefined : () => setEnableSidepanel(!enableSidepanel)}
              />
            </div>
            <Divider layout="vertical" style={{ margin: '0 var(--padding-level-sixteen)' }} />
            <div className="flex align-items-center">
              <div
                className="flex"
              >
                <img src={logo} alt="app-name" style={{ height: '20px' }} />
              </div>
              {selectedApp && (
                <div
                  className="flex flex-column ml-4"
                >
                  <span
                    style={{
                      color: 'var(--cardBackgroundColorOne)',
                      fontFamily: 'var(--fontBarlowRegular)',
                      fontSize: 'var(--font-size-xs)',
                    }}
                  >
                    {t('AppSelector.applicationLabel')}
                  </span>
                  <span
                    className="mt-1"
                    style={{
                      color: 'var(--cardBackgroundColorOne)',
                      fontFamily: 'var(--fontBarlowSemiBold)',
                      fontSize: 'var(--font-size-md)',
                    }}
                  >
                    {`${t(`AppSelector.${selectedApp?.segment?.toLowerCase()}Label`)} - ${selectedApp?.env}`}
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className="flex">
            <Divider layout="vertical" style={{ margin: '0 var(--padding-level-sixteen)' }} />
            <div
              style={{
                display: 'flex',
                cursor: !!appRoles ? 'pointer' : 'auto',
                alignItems: 'center',
                alignSelf: 'center',
                height: '85%',
                width: '240px',
                justifyContent: 'space-between',
              }}
              onClick={(e) => {
                !!appRoles && op_settings.current?.toggle(e);
              }}
              className="role-selector-container"
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--space-base)',
                }}
              >
                <div className="rol-icon-box" style={{ justifySelf: 'left' }}>
                  <i className="iu iu-icon-user" />
                </div>
                <div className="role-text-container">
                  <div className=" ui-input-wrapper">
                    <div className="label-container">
                      <label
                        htmlFor="rol-text"
                        className="block "
                        style={{ fontSize: "var(--font-size-xs)" }}
                      >{selectedApp?.appid ? t('Roles.rolSelectorTitleButton') : t('Roles.typeLabel')}</label>
                    </div>
                    <span className="">
                      <p
                        id="rol-text"
                        className="p-component block"
                        style={{
                          fontFamily: "var(--fontBarlowSemiBold)",
                          maxHeight: "44px",
                          overflow: "hidden",
                          lineHeight: "1.5",
                        }}
                      >
                        {selectedApp?.appid
                          ? selectedApp?.rolename
                          : (dataRolesByTenant?.length > 0 && (isAdminRoleType ? t('Roles.adminRoleTitle') : t('Roles.applicationRoleTitle')))}
                      </p>
                    </span>
                  </div>
                </div>
              </div>
              {
                !!appRoles &&
                <div className="rol-icon-box ml-3" style={{ justifySelf: 'right' }}>
                  <i className="iu iu-icon-down" />
                </div>
              }
              {/* className="hidden sm:block p-button-header st-btn nofocus" */}
            </div>
            <Divider layout="vertical" style={{ margin: '0 var(--padding-level-sixteen)' }} />
            <div id="overlayPerfil" className="flex align-items-center justify-content-center">
              <div
                className="profile-container p-myprofile"
                onClick={(e) => {
                  setShowLangComponent(false);
                  op_profile.current?.toggle(e);
                }}
              >
                <div className="p_header_title hidden lg:block">
                  <h2
                    style={{
                      fontFamily: 'var(--fontBarlowSemiBold)',
                      fontSize: 'var(--font-size-xl)',
                    }}
                  >{user?.name + ' ' + user?.lastname}</h2>
                  <h6
                    style={{
                      fontFamily: 'var(--fontBarlowSemiBold)',
                      fontSize: 'var(--font-size-l)',
                    }}
                  >{tenantParentName}</h6>
                </div>
                <Avatar
                  image={dataBrandingObject?.isotypelogo?.url || mainTenantIsotypeLogo}
                  className="w-3rem h-3rem ml-3 p-slide-menu-avatar"
                  shape="square"
                />
              </div>
            </div>
          </div>
        </nav>
        <div
          className="flex"
          id={(hasAlert && !!selectedApp) ? "environment-messages-alert-show" : "environment-messages-alert-hide"}
        >
          <Messages
            ref={messageRef}
            id="environment-messages-component"
            onRemove={(e) => {
              handleModalProps("alert", false);
            }}
            className="environment-messages-alert"
          />
          <i
            id="icon-close-message"
            className="iu iu-icon-error"
            onClick={() => handleModalProps("alert", false)}
          />
        </div>
      </header>

      <OverlayPanel
        key="role-selector"
        dismissable
        ref={op_settings}
        id="overlay_panel_role_selector"
        style={{ width: "352px" }}
      >
        {OverlayRoleSelectorContent()}
      </OverlayPanel>

      <OverlayPanel
        key="profile"
        dismissable
        ref={op_profile}
        id="overlay_panel"
        style={{ width: "352px" }}
        className="overlaypanel-demo"
      >
        {OverlayProfileContent()}

      </OverlayPanel>

      <SidePanel
        items={[...menuCompleted,
        {
          "label": "CloseSession",
          "icon": "iu iu-icon-exit",
          "actionType": "logout"
        }
        ]}
        visible={isBigScreen ? true : enableSidepanel}
        setEnableSidepanel={setEnableSidepanel}
        isBigScreen={isBigScreen}
        handleModalProps={handleModalProps}
      />
      <NewCustomDialog
        title={modalProps.title}
        visible={modalProps.visible}
        content={modalProps.content}
        handleModalState={setModalProps}
        onConfirm={modalProps.onConfirm}
        closable={modalProps.closable}
        acceptLabel={modalProps.acceptLabel}
        rejectLabel={modalProps.rejectLabel}
        onReject={modalProps.onReject}
      />
    </React.Fragment>
  );
};
